
  import property from "@/mixins/property";
  import propertyFormat from "@/mixins/propertyFormat";

  export default {
    name: "MapModule",
    mixins: [
      property,
      propertyFormat,
    ],
    props: {
      markerHoverId: {
        default: null
      },
      newLat: {
        default: null
      },
      newLon: {
        default: null
      }
    },
    data() {
      return {
        latitudeAVG: 0,
        longitudeAVG: 0
      }
    },
    methods: {
      setCenterMap() {
        this.map = this.$refs.pmap.mapObject;
        this.map.setView(L.latLng(this.newLat, this.newLon), 15);
        this.map.closePopup();
      },
      propertyHover(property) {
        this.$emit('property-hover', property.id)
      },
      generateAvgCoordinates() {
        let latSum = null;
        let longSum = null;
        this.propertiesList.map((property) => {
          latSum += parseFloat(property.latitude);
          longSum += parseFloat(property.longitude);
        });
        const latAvg = (latSum / this.propertiesList.length);
        const longAvg = (longSum / this.propertiesList.length);
        this.latitudeAVG = isNaN(latAvg) ? 0 : latAvg;
        this.longitudeAVG = isNaN(longAvg) ? 0 : longAvg;
      },
      setBounds() {
        this.map = this.$refs.pmap.mapObject;
        let coordinates = [];
        this.propertiesList.map((property) => {
          coordinates.push([property.latitude, property.longitude]);
        });
        let bounds = new L.latLngBounds(coordinates);
        this.map.setBounds(bounds);
      }
    },
    watch: {
      properties: {
        immediate: true,
        handler() {
          this.generateAvgCoordinates()
          // this.setBounds()
        }
      },
      markerHoverId(newVal) {
        newVal && this.setCenterMap();
      }
    }
  }
